module.exports = __webpack_public_path__ + "static/img/badge-no-spray-action.0b84c85.svg";